export const LOADING = 'HOME_LOADING';
export const CURRENT_PATH = "CURRENT_PATH";
